import request from '@/utils/request';

// 获取登录门店信息
export function getLoginShopInfoDetail(data) {
  return request({
    url: '/shop/info/getLoginShopInfoDetail',
    method: 'POST',
    data
  });
}
// 获取登录门店信息-修改门店信息
export function updateShopDefault(data) {
  return request({
    url: '/shop/info/updateShopDefault',
    method: 'POST',
    data
  });
}
// 获取登录门店信息-修改密码
export function updateUserPassword(data) {
  return request({
    url: '/shop/user/updateUserPassword',
    method: 'POST',
    data
  });
}
// 获取门店用户分页列表
export function queryShopUserPageList(data) {
  return request({
    url: '/shop/user/queryShopUserPageList',
    method: 'POST',
    data
  });
}
// 获取门店用户分页列表-新增门店用户
export function saveShopUser(data) {
  return request({
    url: '/shop/user/saveShopUser',
    method: 'POST',
    data
  });
}
// 获取门店用户分页列表-修改门店用户
export function updateShopUser(data) {
  return request({
    url: '/shop/user/updateShopUser',
    method: 'POST',
    data
  });
}
// 获取门店用户分页列表-获取门店用户明细
export function fetchShopUserDetailById(data) {
  return request({
    url: '/shop/user/fetchShopUserDetailById',
    method: 'POST',
    data
  });
}
// 获取门店用户分页列表-删除门店用户
export function removeShopUserById(data) {
  return request({
    url: '/shop/user/removeShopUserById',
    method: 'POST',
    data
  });
}
// 获取门店用户分页列表-更新门店用户状态
export function updateShopUserStatus(data) {
  return request({
    url: '/shop/user/updateShopUserStatus',
    method: 'POST',
    data
  });
}
// 获取门店用户分页列表-更新门店用户密码
export function updateShopUserPassword(data) {
  return request({
    url: '/shop/user/updateShopUserPassword',
    method: 'POST',
    data
  });
}
/* 管理员-所有角色状态正常的角色信息列表 */
export function queryAllRoleList(data) {
  return request({
    url: '/role/queryAllRoleList',
    method: 'POST',
    data
  });
}
/* 角色管理-获取角色信息列表 */
export function queryRolePageList(data) {
  return request({
    url: '/role/queryRolePageList',
    method: 'POST',
    data
  });
}
/* 角色管理-删除 */
export function removeRoleById(data) {
  return request({
    url: '/role/removeRoleById',
    method: 'POST',
    data
  });
}
/* 角色管理-新增 */
export function saveRole(data) {
  return request({
    url: '/role/saveRole',
    method: 'POST',
    data
  });
}
/* 角色管理-修改 */
export function updateRole(data) {
  return request({
    url: '/role/updateRole',
    method: 'POST',
    data
  });
}
/* 角色管理-修改明细 */
export function fetchRoleDetailById(data) {
  return request({
    url: '/role/fetchRoleDetailById',
    method: 'POST',
    data
  });
}
/* 角色管理-获取树形结构系统菜单列表 */
export function queryMenuTreeList(data) {
  return request({
    url: '/menu/queryMenuTreeList',
    method: 'POST',
    data
  });
}
/* 新增门店配置 */
export function saveOrUpdateShopConfig(data) {
  return request({
    url: '/shop/config/saveOrUpdateShopConfig',
    method: 'POST',
    data
  });
}
/* 获取门店配置明细 */
export function fetchShopConfigDetail(data) {
  return request({
    url: '/shop/config/fetchShopConfigDetail',
    method: 'POST',
    data
  });
}
/* 新增或修改门店微信配置 */
export function saveOrUpdateWxPayConfig(data) {
  return request({
    url: '/shop/config/saveOrUpdateWxPayConfig',
    method: 'POST',
    data
  });
}
/* 获取门店微信配置明细 */
export function fetchShopWxPayConfigDetail(data) {
  return request({
    url: '/shop/config/fetchShopWxPayConfigDetail',
    method: 'POST',
    data
  });
}
/* 获取省市区三级联动数据 */
export function queryAreaTreeList(data) {
  return request({
    url: '/system/area/queryAreaTreeList',
    method: 'POST',
    data
  });
}

// ========== 平台管理-多店铺管理 API ==========
export function queryShopInfoPageList(data) {
  return request({
    url: '/shop/info/queryShopInfoPageList',
    method: 'POST',
    data
  });
}
export function saveShopInfo(data) {
  return request({
    url: '/shop/info/saveShopInfo',
    method: 'POST',
    data
  });
}
export function updateShopInfo(data) {
  return request({
    url: '/shop/info/updateShopInfo',
    method: 'POST',
    data
  });
}
export function fetchShopInfoDetailById(data) {
  return request({
    url: '/shop/info/fetchShopInfoDetailById',
    method: 'POST',
    data
  });
}
export function removeShopInfoById(data) {
  return request({
    url: '/shop/info/removeShopInfoById',
    method: 'POST',
    data
  });
}
export function updateShopInfoStatus(data) {
  return request({
    url: '/shop/info/updateShopInfoStatus',
    method: 'POST',
    data
  });
}
export function updateShopInfoDefault(data) {
  return request({
    url: '/shop/info/updateShopInfoDefault',
    method: 'POST',
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/shop.js